import useMediaQuery from '@mui/material/useMediaQuery';
import { MOBILE_INPUT_FOCUS_SUPPRESSION_QUERY, isMobileNavigator } from '@/lib/inputFocus';

export function useCanAutoFocusInput(): boolean {
  const hasPhonePointer = useMediaQuery(MOBILE_INPUT_FOCUS_SUPPRESSION_QUERY, { noSsr: true });
  return !hasPhonePointer && !isMobileNavigator();
}
